import React from "react";

const ConfigPaudSdMiPaketA = {
    Apk: {
        title: "APK SD/MI/Paket A",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 7-12',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp712_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp712_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp712_jumlah',
                    },
                ]
            },
        ]
    },
    Apm: {
        title: "APM SD/MI/Paket A",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 7-12',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp712_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp712_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp712_jumlah',
                    },
                ]
            },
        ]
    }
}

export default ConfigPaudSdMiPaketA;